import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { RegisterPermissionType } from '@assetaccountant/api/models/register-permission-type';

import { RegisterIntegration } from '@assetaccountant/core/models/register-integration';
import { AuthorizationService } from '@assetaccountant/core/services/authorization.service';
import { ModalService } from '@assetaccountant/core/services/modal.service';
import { setupModal, TypedNgbModal } from '@assetaccountant/core/utils/typed-modal';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../../environments/environment';
import { SageConnectModalWrapperComponent } from '../components/collect-integration-credentials/sage-connect/sage-connect-modal-wrapper.component';
import { ConnectIntegrationResponse } from '../models/common/connect-integration-response';
import { SetSageJournalCommand } from '../models/common/set-sage-journal-command';
import { ConnectSageCommand } from '../models/sage/connect-sage-command';
import { ListSageEntitiesResponse } from '../models/sage/list-sage-entities-response';
import { ListSageJournalsResponse } from '../models/sage/list-sage-journals-response';
import { SageJournal } from '../models/sage/sage-journal';

@Injectable({
  providedIn: 'root',
})
export class SageService {
  constructor(
    private http: HttpClient,
    private modalService: ModalService,
    private authorizationService: AuthorizationService,
    @Inject(NgbModal) public ngbModal: TypedNgbModal,
  ) {}

  connect(command: ConnectSageCommand) {
    return this.http.post<ConnectIntegrationResponse>(
      `${environment.servicesApiUrl}/api/v2/integrations/sageIntacct`,
      command,
    );
  }

  listEntities(username: string, password: string, companyId: string) {
    return this.http.post<ListSageEntitiesResponse>(
      `${environment.servicesApiUrl}/api/v2/integrations/sageIntacct/entities`,
      { companyId, username, password },
    );
  }

  listJournals(integrationId: string) {
    return this.http.get<ListSageJournalsResponse>(
      `${environment.servicesApiUrl}/api/v2/integrations/${integrationId}/sageIntacct/journals`,
    );
  }

  setJournal(integrationId: string, command: SetSageJournalCommand) {
    return this.http.post<{ journal: SageJournal }>(
      `${environment.servicesApiUrl}/api/v2/integrations/${integrationId}/sageIntacct/journals`,
      command,
    );
  }

  handleError(registerId, httpError, integration: RegisterIntegration) {
    if (
      (httpError.error &&
        httpError.error.errors &&
        Array.isArray(httpError.error.errors) &&
        httpError.error.errors[0].includes('XL03000006')) ||
      httpError.status === 403
    ) {
      if (
        registerId &&
        this.authorizationService.isRegisterAuthorized(
          registerId,
          RegisterPermissionType.CreateIntegrationConnection,
        )
      ) {
        this.modalService
          .showErrorModal(
            'We were unable to authenticate with Sage Intacct, please reconnect and try again.',
            'Authentication Failure',
            'Reconnect',
          )
          .subscribe(_ =>
            setupModal(this.ngbModal.open(SageConnectModalWrapperComponent), modal => {
              modal.registerId = integration.registerId;
              modal.entityId = integration.metadata?.EntityId;
              modal.companyName = integration.companyName;
              modal.companyId = integration.tenantId;
            }),
          );
      } else {
        this.modalService.showErrorModal(
          'We were unable to authenticate with Sage Intacct, please ask an administrator to reconnect this register',
          'Authentication Failure',
          'OK',
        );
      }
    } else {
      throw httpError;
    }
  }
}
